
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'LayoutBrand',
})
export default class LayoutBrand extends Vue {
    /** 是否有tabbar */
    @Prop({ type: Boolean }) public tabbar?: boolean;

    public onClick() {
        location.href = 'https://www.qizengzhang.cn';
    }
}
